<template>
    <div>
        <template v-if="isCustom">
            <template v-if="isFinish">
                <div class="comment-result-container">
                    <div class="comment-result_title">
                        <img src="@/assets/instantMessaging/ic_comment_success.svg"
                             class="comment-result_icon">
                        <span>评价成功，感谢您的支持！</span>
                    </div>
                    <h4 class="comment-result_subtitle">评价对象：{{nick}}</h4>
                    <div class="comment-result_content">
                        <template v-if="evaluationInfo.grade === 1">
                            <img src="@/assets/instantMessaging/ic_dissatisfied_yellow.svg"
                                 class="comment-result_content_icon">
                            <span class="comment-result_content_text">不满意</span>
                        </template>
                        <template v-else-if="evaluationInfo.grade === 3">
                            <img src="@/assets/instantMessaging/ic_commonly_yellow.svg"
                                 class="comment-result_content_icon">
                            <span class="comment-result_content_text">基本满意</span>
                        </template>
                        <template v-else-if="evaluationInfo.grade === 5">
                            <img src="@/assets/instantMessaging/ic_satisfied_yellow.svg"
                                 class="comment-result_content_icon">
                            <span class="comment-result_content_text">满意</span>
                        </template>
                    </div>
                    <div class="comment-result_desc">
                        “{{this.evaluationInfo.comment}}”
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="comment-evaluate-container">
                    <h3 class="comment-evaluate_title">{{nick}}</h3>
                    <h4 class="comment-evaluate_subtitle">邀请您对其服务进行评价</h4>
                    <div class="comment-evaluate_select_box">
                        <label class="comment-evaluate_select_item">
                            <input type="radio"
                                   v-show="false"
                                   name="evaluate"
                                   v-model="selected"
                                   :value="1">
                            <img v-if="selected === 1"
                                 src="@/assets/instantMessaging/ic_dissatisfied_yellow.svg"
                                 class="comment-evaluate_select_icon">
                            <img v-else
                                 src="@/assets/instantMessaging/ic_dissatisfied_grey.svg"
                                 class="comment-evaluate_select_icon">
                            <span class="comment-evaluate_select_text">不满意</span>
                        </label>
                        <label class="comment-evaluate_select_item">
                            <input type="radio"
                                   v-show="false"
                                   name="evaluate"
                                   v-model="selected"
                                   :value="3">
                            <img v-if="selected === 3"
                                 src="@/assets/instantMessaging/ic_commonly_yellow.svg"
                                 class="comment-evaluate_select_icon">
                            <img v-else
                                 src="@/assets/instantMessaging/ic_commonly_grey.svg"
                                 class="comment-evaluate_select_icon">
                            <span class="comment-evaluate_select_text">基本满意</span>
                        </label>
                        <label class="comment-evaluate_select_item">
                            <input type="radio"
                                   v-show="false"
                                   name="evaluate"
                                   v-model="selected"
                                   :value="5">
                            <img v-if="selected === 5"
                                 src="@/assets/instantMessaging/ic_satisfied_yellow.svg"
                                 class="comment-evaluate_select_icon">
                            <img v-else
                                 src="@/assets/instantMessaging/ic_satisfied_grey.svg"
                                 class="comment-evaluate_select_icon">
                            <span class="comment-evaluate_select_text">满意</span>
                        </label>
                    </div>
                    <div class="comment-evaluate_input_box">
                    <textarea rows="3"
                          maxlength="500"
                          class="comment-evaluate_input_textarea"
                          type="textarea"
                          placeholder="请写下对本次退货服务的意见吧～"
                          v-model="comment" />
                        <div class="comment-evaluate_input_limit">{{comment.length}}/500</div>
                    </div>
                    <button class="comment-evaluate_submit" @click="submitEvaluation">提交评价</button>
                </div>
            </template>
         
        </template>
        <template v-else>
            <template v-if="isFinish">
                <div class="comment-container">
                    <div class="comment-invitation">
                        <span class="comment-invitation_title">退货人已评价</span>
                    </div>
                    <div class="comment-object">
                        评价对象：{{nick}}
                    </div>
                    <div class="comment-result_content">
                        <template v-if="evaluationInfo.grade === 1">
                            <img src="@/assets/instantMessaging/ic_dissatisfied_yellow.svg"
                                 class="comment-result_content_icon">
                            <span class="comment-result_content_text">不满意</span>
                        </template>
                        <template v-else-if="evaluationInfo.grade === 3">
                            <img src="@/assets/instantMessaging/ic_commonly_yellow.svg"
                                 class="comment-result_content_icon">
                            <span class="comment-result_content_text">基本满意</span>
                        </template>
                        <template v-else-if="evaluationInfo.grade === 5">
                            <img src="@/assets/instantMessaging/ic_satisfied_yellow.svg"
                                 class="comment-result_content_icon">
                            <span class="comment-result_content_text">满意</span>
                        </template>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="comment-container">
                    <div class="comment-invitation">
                        <img src="@/assets/instantMessaging/ic_comment.svg" class="comment-invitation_icon"/>
                        <span class="comment-invitation_title">已向退货人发送评价邀请</span>
                    </div>
                    <div class="comment-object">
                        评价对象：{{nick}}
                    </div>
                </div>
            </template>
          
        </template>

    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import api from '@/service/modules/instantMessaging';
import { messageSenderRole } from '../../utils';

export default {
    name: "userCommentElement",
    filters: {
    },
    props: {
        payload: {
            type: Object,
            required: true
        },
        message: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
	        selected: 0,
	        comment: '',
	        evaluationInfo: {},
	        timer: null,
	        preTime: null
        }
    },
    computed: {
	    ...mapGetters('instantMessaging', ['isCustom']),
	    ...mapState('instantMessaging', ['currentMemberList']),
	    isFinish() {
	        return this.evaluationInfo.comment && this.evaluationInfo.grade;
	    },
	    payloadObject() {
	        return JSON.parse(this.payload.description);
	    },
	    nick() {
		    return `${this.message.nick}(${messageSenderRole(this.message, this.currentMemberList)})`
	    }
    },
    watch: {
	    selected: function(val, oldVal) {
		    console.log(val, oldVal)
	    }
    },
    beforeCreate() {},
    created() {
        console.log(this.message);
    },
    mounted() {
	    if (this.timer) {
		    cancelAnimationFrame(this.timer);
	    }
	    this._timeAnimate();
    },
    methods: {
	    getEvaluation() {
	        if (this.timer && this.isFinish) {
		        cancelAnimationFrame(this.timer);
		        this.timer = null;
		        return false;
	        }

		    api.getEvaluate({
			    targetId: this.payloadObject.userId,
			    groupId: this.payloadObject.groupId
		    }).then(res => {
			    this.evaluationInfo = res.data;
		    })
	    },
	    async submitEvaluation() {
            const res = await api.updateEvaluate({
	            targetId: this.payloadObject.userId,
	            groupId: this.payloadObject.groupId,
	            grade: this.selected,
	            comment: this.comment
            });
            this.getEvaluation();
	    },
	    _timeAnimate(){
		    this.timer = requestAnimationFrame(this._timeAnimate);
		    const second = Date.parse(new Date());
		    // 每10秒重新获取一次数据
		    if (second - this.preTime < 10 * 1e3) {
			    return false;
		    }
		    this.preTime = second;
		    this.getEvaluation();
	    }
    },
    beforeDestroy() {
        if (this.timer) {
	        cancelAnimationFrame(this.timer);
	        this.timer = null;
        }
    }
}
</script>

<style scoped lang="less">
.comment-container {
    width: 247px;
    margin: 0 auto 4px;
    background: #F0F1F5;
    border-radius: 4px;
    padding: 10px 0;
    text-align: center;

    .comment-invitation {
        display: flex;
        justify-content: center;
        align-items: center;

        .comment-invitation_icon {
            margin-right: 4px;
            height: 12px;
            width: 12px;
        }
        .comment-invitation_title {
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #1E2226;
            letter-spacing: 0;
            line-height: 16px;
        }
    }

    .comment-object {
        margin-top: 6px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: #9DA0A4;
        letter-spacing: 0;
    }

    .comment-result {
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;

        .comment-result_icon {
            width: 33px;
            height: 33px;
            margin-right: 5px;
        }

        .comment-result_evaluate {
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 16px;
            color: #6B4F41;
            letter-spacing: 0;
            line-height: 22px;
        }
    }

    .comment-result_content {
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: center;

        .comment-result_content_icon {
            width: 32px;
            height: 32px;
            margin-right: -12px;
            position: relative;
            border-radius: 50%;
            z-index: 2;
        }

        .comment-result_content_text {
            padding: 3.6px 10.1px 3.4px 12.9px;
            line-height: 20px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #6B4F41;
            letter-spacing: 0;
            text-align: center;
            border-radius: 0 67.37px 67.37px 0;
            position: relative;
            z-index: 1;
        }
    }
}

.comment-evaluate-container {
    margin: 0 4px;
    padding: 18px 16px 20px;
    width: 343px;
    background-color: #FFFFFF;
    text-align: center;

    .comment-evaluate_title {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        line-height: 22px;
    }

    .comment-evaluate_subtitle {
        margin-top: 2px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        line-height: 22px;
    }

    .comment-evaluate_select_box {
        display: flex;
        justify-content: space-around;
        margin-top: 20px;

        .comment-evaluate_select_item {
            display: flex;
            flex-direction: column;
            align-items: center;

            .comment-evaluate_select_icon {
                width: 32px;
                height: 32px;
                display: block;
            }

            .comment-evaluate_select_text {
                margin-top: 5px;
                display: block;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 20px;
                text-align: center;
            }

            input[type='radio']:checked ~ .comment-evaluate_select_text {
                color: #333333;
            }
        }
    }

    .comment-evaluate_input_box {
        margin: 22px auto 0;
        width: 311px;
        background-color: #F8F9FC;
        padding: 12px 10px 10px 12px;
        border-radius: 8px;

        .comment-evaluate_input_textarea {
            width: 100%;
            line-height: 20px;
            border: 0;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            letter-spacing: 0;
            background-color: transparent;
        }

        .comment-evaluate_input_textarea::placeholder {
            line-height: 20px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #CCCCCC;
            letter-spacing: 0;
        }

        .comment-evaluate_input_limit {
            margin-top: 4px;
            text-align: right;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            letter-spacing: 0;
            line-height: 16px;
        }
    }

    .comment-evaluate_submit {
        margin: 20px auto 0;
        padding: 8px 24px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #26C080;
        letter-spacing: 0;
        border: 1px solid #36B374;
        border-radius: 23px;
        background-color: transparent;
        text-align: center;
    }
}

.comment-result-container {
        margin: 0 4px;
        padding: 19px 32px 25px 32px;
        width: 343px;
        background-color: #FFFFFF;
        text-align: center;

        .comment-result_title {
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            line-height: 22px;

            .comment-result_icon {
                width: 16px;
                height: 16px;
                vertical-align: middle;
                display: inline-block;
                margin-right: 5.4px;
            }
        }

        .comment-result_subtitle {
            line-height: 22px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            letter-spacing: 0;
            text-align: center;
        }

        .comment-result_content {
            margin-top: 15px;
            display: flex;
            align-items: center;
            justify-content: center;

            .comment-result_content_icon {
                width: 32px;
                height: 32px;
                margin-right: -12px;
                position: relative;
                border-radius: 50%;
                z-index: 2;
            }

            .comment-result_content_text {
                padding: 3.6px 10.1px 3.4px 12.9px;
                line-height: 20px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #6B4F41;
                letter-spacing: 0;
                text-align: center;
                border-radius: 0 67.37px 67.37px 0;
                background-color: #FCF8ED;
                position: relative;
                z-index: 1;
            }
        }

        .comment-result_desc {
            margin: 23px auto 0;
            max-width: 279px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            letter-spacing: 0;
            line-height: 17px;
            text-align: center;
        }
    }
</style>
